import React from "react";
import { Typography, Grid, CardActions } from "@material-ui/core";
import LinkedMessage from "../../universal-login/LinkedMessage";
import theme from "../../../common/theme";
import FormButton from "../../common/FormButton";
import { useTranslation } from "react-i18next";
import auth0Config from "../../../utils/auth0ConfigHelper";

interface LoginFormControlsProps {
  isSubmitting: boolean;
}

const LoginFormControls: React.FC<LoginFormControlsProps> = ({
  isSubmitting,
}) => {
  const { t } = useTranslation();

  return (
    <>
      {auth0Config?.dict.signin.title !== "delegated-admin-app" && (
        <CardActions disableSpacing>
          <Typography
            data-testid="loginAppendix"
            variant="body2"
            align="center"
          >
            {t("login.loginAppendix")}
          </Typography>
        </CardActions>
      )}
      <CardActions disableSpacing>
        <div className="captcha-container"></div>
      </CardActions>
      <CardActions disableSpacing>
        <Grid
          container
          direction="row"
          justify="space-between"
          alignItems="center"
          style={{ marginTop: theme.spacing(2) }}
        >
          <Grid item>
            {auth0Config?.dict.signin.title !== "delegated-admin-app" && (
              <Typography variant="body1" component="p">
                <LinkedMessage
                  i18nKey="login.forgotPassword"
                  to="reset-password"
                  testId="resetPasswordLink"
                  gtmEvent="forgotPasswordLink"
                />
              </Typography>
            )}
          </Grid>
          <Grid item>
            <FormButton
              waiting={isSubmitting}
              label={t("login.button")}
              testId="loginButton"
              name="submit"
            />
          </Grid>
        </Grid>
      </CardActions>
    </>
  );
};

export default LoginFormControls;
